import React from 'react';

import { Flex } from '@chakra-ui/react';

import { VIEWS_FILTER_KEYS } from 'constants/ProjectConstants';

import { TagOutlined } from 'uiToolkitV1/Tag/TagOutlined';

// const sampleTagObjData = {
//   id: 1,
//   title: 'Tag 1',
//   StartIcon: null,
//   startAvatarSrc: null
// };

export const TagOutlinedList = ({ tagList, onRemove, onClickHandler }) => (
  <Flex justifyContent="flex-start" rowGap={3} columnGap={3} flexWrap="wrap">
    {tagList.map((item) => (
      <TagOutlined
        key={item.id}
        onRemove={onRemove && item.id !== VIEWS_FILTER_KEYS.BASE_COHORT ? () => onRemove(item.id) : undefined}
        onClick={onClickHandler ? () => onClickHandler(item.id) : undefined}
        StartIcon={item.StartIcon}
        startAvatarSrc={item.startAvatarSrc}
      >
        {item.title}
      </TagOutlined>
    ))}
  </Flex>
);
